import { toFloatBigNumber } from '@/util/big'
import { formatEther, parseEther } from 'ethers/lib/utils'

export const useFormatNativeCurrency = () => formatEther
export const useParseNativeCurrency = () => parseEther
export const useToFloatNativeCurrency = () => toFloatBigNumber
